<template>
    <div 
        class="o-guide-switch"
        :style="configStyles"
    >
        <ASwitch
            v-model="localValue"
            :true-value="trueValue"
            :false-value="falseValue"
            @onChange="onChange"
        > 
            <template #open>
                <span class="content-container">
                    <svg-icon
                        original
                        :name="fastGuideIconBlackPath"
                        class="switch-icon switch-icon--fast"
                    />
                    <svg-icon
                        original
                        :name="easyGuideIconWhitePath"
                        class="switch-icon switch-icon--easy"
                    />
                </span>
            </template>
            <template #close>
                <span class="content-container">
                    <svg-icon
                        original
                        :name="fastGuideIconWhitePath"
                        class="switch-icon switch-icon--fast"
                    />
                    <svg-icon
                        original
                        :name="easyGuideIconBlackPath"
                        class="switch-icon switch-icon--easy"
                    />
                </span>
            </template>
        </ASwitch>
    </div>
</template>

<script>
import { computed } from '@vue/composition-api';

import { mapGetters } from 'vuex';

import ASwitch from '../../atoms/a-switch';

export default {
    name: 'OGuideSwitch',
    components: {
        ASwitch
    },
    props: {
        value: {
            type: [String, Number, Boolean],
            default: false
        },
        trueValue: {
            type: [String, Number, Boolean],
            default: 'easy'
        },
        falseValue: {
            type: [String, Number, Boolean],
            default: 'fast'
        }
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        commonConfigParams() {
            return this.getMapConfigProp('components.OGuideSwitch.params') || {};
        },
        fastGuideIconWhitePath() {
            return this.commonConfigParams.fastIconWhite
                ? `icons/${this.commonConfigParams.fastIconWhite}`
                : 'icons/fast-way-3-white';
        },
        fastGuideIconBlackPath() {
            return this.commonConfigParams.fastIconBlack
                ? `icons/${this.commonConfigParams.fastIconBlack}`
                : 'icons/fast-way-3-black';
        },
        easyGuideIconWhitePath() {
            return this.commonConfigParams.easyIconWhite
                ? `icons/${this.commonConfigParams.easyIconWhite}`
                : 'icons/easy-way-3-white';
        },
        easyGuideIconBlackPath() {
            return this.commonConfigParams.easyIconBlack
                ? `icons/${this.commonConfigParams.easyIconBlack}`
                : 'icons/easy-way-3-black';
        },
        commonConfigStyles() {
            return this.getMapConfigProp('components.OGuideSwitch.styles') || {};
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.mainFrame.OGuideSwitch.styles`) || {};
        },
        configStyles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        }
    },
    setup(props, { emit }) {
        const localValue = computed({
            get: () => props.value,
            set: value => {
                emit('input', value);
            }
        });

        function onChange(data) {
            emit('onChange', data)
        }

        return {
            localValue,
            onChange
        };
    }
}
</script>

<style lang="scss" src="./theme.scss" />